<div ngbDropdown placement="bottom-center" *ngIf="user$ | async as _user" class="kt-header__topbar-item kt-header__topbar-item--user">
	<div ngbDropdownToggle class="kt-header__topbar-wrapper">
		<div class="kt-header__topbar-user" [ngClass]="{'kt-header__topbar-icon': icon}">
			<span class="kt-header__topbar-welcome" *ngIf="greeting">{{'USER_PROFILE.HI' | translate}}</span>
			<span class="kt-header__topbar-username user-profile-title" *ngIf="greeting"> {{_user.full_name}}</span>
		</div>
	</div>
	<div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround">
		<ul class="kt-nav kt-margin-t-10 kt-margin-b-10">
			<li class="kt-nav__item kt-nav__item--custom kt-margin-t-15">
				<a (click)="logout()" class="btn">{{'AUTH.GENERAL.SIGNOUT' | translate}}</a>
			</li>
		</ul>
	</div>
</div>

<div hidden id="print-section-shift">
	<table *ngIf="shift" style="width:270px;text-align: center;font-size: 10px;">

		<thead>
		</thead>

		<tbody>

			<tr style="font-size: 11px">
				<td style="width:50px;text-align: right;"></td>
				<td style="width:90px;text-align: right;">التاريخ:</td>
				<td style="width:130px;text-align: center;direction: ltr;">{{(moment)(moment().clone().locale('en')).format('DD-MM-YYYY hh:mm:ss')}}</td>
			</tr>
			<tr style="font-size: 11px">
				<td style="width:50px;text-align: right;"></td>
				<td style="width:90px;text-align: right;">الموقع:</td>
				<td style="width:130px;text-align: center;">{{this.shift.area?.area_name}}</td>
			</tr>

			<tr>
				<td colspan="3" style="text-align: center !important;width:200px;line-height: 20px;">
					</td>
			</tr>

			<tr style="font-size: 11px">
				<td style="width:50px;text-align: right;"></td>
				<td style="width:90px;text-align: right;">اسم الكاشير:</td>
				<td style="width:130px;text-align: center;">{{this.shift.user?.full_name}}</td>
			</tr>

			<tr>
				<td colspan="3" style="text-align: center !important;width:200px;line-height: 20px;"></td>
			</tr>

			<tr style="font-size: 11px">
				<td style="width:50px;text-align: right;"></td>
				<td style="width:90px;text-align: right;"> بداية الشفت:</td>
				<td style="width:130px;text-align: center;direction: ltr;">
					{{(moment)(moment(this.shift?.shift_start_date).clone().locale('en')).format('DD-MM-YYYY hh:mm A')}}</td>
			</tr>
			<tr style="font-size: 11px">
				<td style="width:50px;text-align: right;"></td>
				<td style="width:90px;text-align: right;"> نهاية الشفت:</td>
				<td style="width:130px;text-align: center;direction: ltr;">
					{{(moment)(moment(this.shift?.shift_end_date).clone().locale('en')).format('DD-MM-YYYY hh:mm A')}}</td>
			</tr>

			<tr>
				<td colspan="3" style="text-align: center !important;width:200px;line-height: 20px;"></td>
			</tr>

			<tr style="font-size: 11px">
				<td style="width:50px;text-align: right;"></td>
				<td style="width:90px;text-align: right;">قيمة العمليات حسب النظام:</td>
				<td style="width:130px;text-align: center;"
					*ngIf="this.shift.systemAmount && this.shift.systemAmount[0]">
					{{this.shift.systemAmount[0].total_cash_payments}}</td>
			</tr>

			<tr>
				<td colspan="3" style="text-align: center !important;width:200px;line-height: 20px;"></td>
			</tr>

			<tr style="font-size: 11px">
				<td style="width:50px;text-align: right;"></td>
				<td style="width:90px;text-align: right;">قيمة النقدية المستلمة:</td>
				<td style="width:130px;text-align: center;">{{this.shift.amount}}</td>
			</tr>

			<tr>
				<td colspan="3" style="text-align: center !important;width:200px;line-height: 20px;"></td>
			</tr>

			<tr style="font-size: 11px">
				<td style="width:50px;text-align: right;"></td>
				<td style="width:90px;text-align: right;">الفرق:</td>
				<td style="width:130px;text-align: center;"
					*ngIf="this.shift.systemAmount && this.shift.systemAmount[0]">
					{{(this.shift.amount - this.shift.systemAmount[0].total_cash_payments).toFixed(2)}}</td>
			</tr>

			<tr>
				<td colspan="3" style="text-align: center !important;width:200px;line-height: 20px;"></td>
			</tr>

			<tr style="font-size: 11px">
				<td style="width:50px;text-align: right;"></td>
				<td style="width:90px;text-align: right;">عدد العمليات:</td>
			</tr>

		</tbody>
	</table>

	<div style="direction: rtl;margin-top: 5px;" *ngFor="let companyCount of shift?.companyCount;let i = index">
		<div *ngIf="i === 0" style="width:80px;float: right;">&nbsp;</div>
		<div style="width: 100px;float:right;font-size: 11px">
			<div style="width:fit-content;float:right;text-align: right;">{{companyCount.company.company_name}}:</div>
			<div style="width:fit-content;float:right;text-align:right;">{{companyCount.company_count}}</div>
		</div>
		<br *ngIf="((i+1) % 2) === 0" >
		<div class="clearfix" *ngIf="((i+1) % 2) === 0"></div>
		<div *ngIf="((i+1) % 2) === 0" style="width:80px;float:right;">&nbsp;</div>
	</div>
</div>
